// Counts buyer inquiries: taps on an agent's phone or email link. Links opt in
// with the data attributes from ApplicationHelper#inquiry_attributes.
//
// sendBeacon rather than fetch: it is queued by the browser and still delivered
// if the click unloads the page. It can't set headers, so the CSRF token rides
// in the form body, where Rails also looks for it.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-inquiry]')
  if (!link) return

  const { inquiry, inquiryPlacement, inquiryListing, inquiryAgent } = link.dataset
  const data = new FormData()
  data.append('authenticity_token', document.querySelector('meta[name="csrf-token"]')?.content || '')
  data.append('kind', inquiry)
  data.append('placement', inquiryPlacement)
  if (inquiryListing) data.append('listing_id', inquiryListing)
  if (inquiryAgent) data.append('agent_id', inquiryAgent)
  navigator.sendBeacon('/inquiries', data)

  // Lets Google Analytics count it too (gtag is only loaded in production).
  // Mark generate_lead as a key event in GA to see it as a conversion there.
  window.gtag?.('event', 'generate_lead', { method: inquiry, placement: inquiryPlacement })
})
